import { fetchApi } from "../common/api";

export interface PublicApiKey {
  id: string;
  user_id: string;
  name: string;
  is_active: boolean;
  created_at: string;
  last_used_at: string | null;
}

export interface CreatedPublicApiKey {
  key: PublicApiKey;
  api_key: string;
}

export const listApiKeys = () => {
  return fetchApi<PublicApiKey[]>("/api_keys/list", "POST", {});
};

export const createApiKey = (name: string) => {
  return fetchApi<CreatedPublicApiKey>("/api_keys/create", "POST", { name });
};

export const deleteApiKey = (id: string) => {
  return fetchApi<{ success: boolean }>("/api_keys/delete", "POST", { id });
};
